import React, { useState } from "react";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { UserRole } from "../../API";
import { generateClient } from "aws-amplify/api";
import { createUser as createUserMutation } from "../../graphql/mutations";

const client = generateClient();

const CreateUser: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleCreateUser = async () => {
    setIsLoading(true);
    setMessage("");

    try {
      // Create Christopher Medina user in DynamoDB
      const userInput = {
        username: "medina",
        email: "medina@theboosterbox.gg",
        firstName: "Christopher",
        lastName: "Medina",
        displayName: "Christopher Medina",
        profilePictureUrl: null,
        role: UserRole.ADMIN, // Create as admin directly
        profileCompleted: true,
      };

      console.log("Creating user in DynamoDB:", userInput);

      const result = await client.graphql({
        query: createUserMutation,
        variables: {
          input: userInput,
        },
      });

      console.log("User created:", result.data.createUser);

      setMessage(
        "✅ Successfully created Christopher Medina as ADMIN in DynamoDB!"
      );
    } catch (error) {
      console.error("Error creating user:", error);
      setMessage(
        `❌ Error: ${error instanceof Error ? error.message : "Unknown error"}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateTestUsers = async () => {
    setIsLoading(true);
    setMessage("");

    try {
      // Create test users for public standings
      const testUsers = [
        {
          username: "testplayer1",
          email: "test1@example.com",
          firstName: "Test",
          lastName: "Player",
          displayName: "Test Player 1",
          profilePictureUrl: null,
          role: UserRole.PLAYER,
          profileCompleted: true,
        },
        {
          username: "testplayer2",
          email: "test2@example.com",
          firstName: "Test",
          lastName: "Player",
          displayName: "Test Player 2",
          profilePictureUrl: null,
          role: UserRole.PLAYER,
          profileCompleted: true,
        },
        {
          username: "testplayer3",
          email: "test3@example.com",
          firstName: "Test",
          lastName: "Player",
          displayName: "Test Player 3",
          profilePictureUrl: null,
          role: UserRole.PLAYER,
          profileCompleted: true,
        },
      ];

      const results = [];
      for (const userInput of testUsers) {
        console.log("Creating test user:", userInput);
        const result = await client.graphql({
          query: createUserMutation,
          variables: {
            input: userInput,
          },
        });
        results.push(result.data.createUser);
      }

      console.log("Test users created:", results);

      setMessage(
        `✅ Successfully created ${results.length} test users in DynamoDB!`
      );
    } catch (error) {
      console.error("Error creating test users:", error);
      setMessage(
        `❌ Error: ${error instanceof Error ? error.message : "Unknown error"}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-6 max-w-md">
      <Card>
        <CardHeader>
          <CardTitle>Create Users</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-sm text-gray-600">
            <p>Create users directly in DynamoDB to test the application.</p>
            <p className="mt-2">
              <strong>Admin User:</strong> medina@theboosterbox.gg
            </p>
            <p>
              <strong>Test Players:</strong> 3 sample players for public
              standings
            </p>
          </div>

          <Button
            onClick={handleCreateUser}
            disabled={isLoading}
            className="w-full"
          >
            {isLoading ? "Creating..." : "Create User as Admin"}
          </Button>

          <Button
            onClick={handleCreateTestUsers}
            disabled={isLoading}
            className="w-full"
            variant="outline"
          >
            {isLoading ? "Creating..." : "Create Test Players"}
          </Button>

          {message && (
            <div
              className={`p-3 rounded-md text-sm ${
                message.includes("✅")
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              {message}
            </div>
          )}

          <div className="text-sm text-gray-600 mt-4">
            <p>
              <strong>Note:</strong> This bypasses the authentication issues by
              creating the user directly in DynamoDB.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CreateUser;
